<template>
  <div class="column q-mx-auto q-my-auto q-pb-xl">
    <div
      class="row col-auto justify-center"
      style="padding: 3em 0 2em"
    >
      <img
        src="@/assets/icons/Vonix.png"
        class="image"
      >
    </div>

    <div
      v-if="retrySecs > 0 || isLogged"
      class="flex full-width items-center justify-center"
    >
      <q-card
        flat
        bordered
        style="min-width: 350px"
      >
        <q-card-section>
          <div class="text-h6">
            {{ load.loadType }}
          </div>
        </q-card-section>

        <q-separator inset />

        <q-card-section class="q-pt-none">
          <q-linear-progress
            dark
            size="5px"
            rounded
            indeterminate
            color="primary"
            class="q-mt-sm"
          />
        </q-card-section>
      </q-card>
    </div>
    <q-card
      v-else
      flat
      bordered
      class="col bg-blue-grey-1"
    >
      <form @keyup.enter="handleAuth">
        <q-card-section class="pad-panel">
          <div class="column">
            <label
              for="agent"
              class="col"
            >
              <span class="label">
                {{ state.labelAgentCode }}
              </span>

              <input
                id="agent"
                type="text"
                class="fit input-login"
                placeholder="####"
                v-model="agent"
                maxlength="6"
                @keypress="isNumber($event)"
              >
            </label>

            <label
              for="password"
              class="col q-mt-sm"
            >
              <span class="label">
                Senha
              </span>

              <input
                id="password"
                type="password"
                class="fit input-login"
                placeholder="******"
                v-model="password"
                minlength="6"
                @keypress="isNumber($event)"
              >
            </label>

            <div class="col text-right mt20">
              <q-btn
                dense
                :loading="isLoading"
                :disable="disable || isLoading"
                @click="handleAuth"
                label="Entrar"
                color="primary"
                class="q-px-md text-grey-4 full-width"
              />
            </div>
            <span
              class="text-negative text-caption text-center q-mt-md"
              v-if="cognitoError && !isLoading"
            >
              {{ cognitoError }}
            </span>
          </div>
        </q-card-section>
      </form>
    </q-card>

    <div
      class="col"
      v-if="showSettings"
    >
      <div class="row items-center">
        <div class="col configuracoes-link">
          <router-link :to="{ name: ROUTE_SETTINGS }">
            <span>Ver configurações</span>
          </router-link>
        </div>

        <div class="col appVersion">
          VP: <b>{{ version }}</b>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { ROUTE_SETTINGS } from '@/router/constants'
import { getVersion } from '@/libs/version'

export default {
  data () {
    return {
      agent: '',
      password: '',
      version: getVersion(),
      ROUTE_SETTINGS
    }
  },

  computed: {
    ...mapGetters({
      cognitoError: 'authModule/cognitoError',
      retrySecs: 'sipModule/retrySecs',
      isLogged: 'authModule/isLogged',
      isLoading: 'authModule/isLoading'
    }),
    ...mapState({
      load: ({ agentModule }) => {
        let loadType = agentModule?.session?.loadType ?? ''
        if (!loadType) loadType = 'Carregando'

        if (loadType === 'sip') loadType = 'Conectando Ramal'
        if (loadType === 'sipDisconnect') loadType = 'Desconectando Ramal'
        if (loadType === 'logout') loadType = 'Deslogando Agente'
        if (loadType === 'session') loadType = 'Carregando dados do Agente'

        return { loadType }
      },

      state: ({ sipModule, connectionModule, agentModule }) => {
        const { attendanceId } = sipModule.login
        const sipConnected = sipModule.sipConnected
        const connected = connectionModule.connected
        const labelAgentCode = agentModule?.provision?.labelAgentCode || 'Matrícula'

        return {
          connected,
          attendanceId,
          sipConnected,
          labelAgentCode
        }
      }
    }),

    disable () {
      return String(this.agent).trim().length < 4 || String(this.password).trim().length < 6
    },

    showSettings () {
      return !!(!this.isLogged && !this.isLoading)
    }
  },

  methods: {
    ...mapActions({
      login: 'authModule/login'
    }),

    handleAuth () {
      if (this.isLoading) return
      const { agent, password } = this

      if (password.length < 6) {
        return this.$q.notify({
          message: 'A senha deve ter no mínimo 6 caracteres',
          color: 'negative',
          position: 'top'
        })
      }

      this.login({ agent, password })
    },

    isNumber: (evt) => {
      const charCode = evt.which ? evt.which : evt.keyCode
      const isNotNum = (charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46
      return isNotNum ? evt.preventDefault() : true
    }
  }
}
</script>

<style lang="sass" scoped>
.panel
  width: 100%
  max-width: 300px

.configuracoes-link
  a
    text-decoration: none
    font-weight: normal
    font-size: 13px
    line-height: 15px
    color: #065AA1

.pad-panel
  padding: 16px 28px 24px

.mt20
  display: block
  margin-top: 20px

.label
  font-weight: 500
  font-size: 14px
  line-height: 16px
  color: #263238

.settings
  position: relative
  float: right
  z-index: 999

.settings-icon
  width: 18px
  height: 18px

.settings-icon > path
  fill: #37474F

.input-login
  max-height: 40px
  border: 1px solid #CFD8DC
  border-radius: 2px
  padding: 8px 8px
  color: #263238
  &:hover
    border: 1px solid #eee
  &:focus
    border: 1px solid #065AA1
    outline: none
  &::-webkit-input-placeholder
    color: #263238
    opacity: 0.5

.appVersion
  font-weight: normal
  font-size: 12px
  line-height: 14px
  text-align: right
  color: #757575

.image
  height: 120px
</style>
